import { useCallback } from "react";
import { useAppDispatch } from "@/lib/store";
import {
  endCommonLoading,
  startCommonLoading,
} from "@/lib/store/reducers/uiState";

export const useLoadingState = () => {
  const dispatch = useAppDispatch();

  const showLoader = useCallback(
    () => dispatch(startCommonLoading()),
    [dispatch],
  );

  const hideLoader = useCallback(
    () => dispatch(endCommonLoading()),
    [dispatch],
  );

  return { dispatch, showLoader, hideLoader };
};
